/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MapLayout.scss';
import MapHeader from '../MapHeader';
import PrintHeader from '../PrintHeader';
import { connect } from 'react-redux';

const printHeader2 = (
  <div style={{ position: 'absolute', top: '0' }} className='printHeader'>printheader2</div>
)

class MapLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <div style={{fontSize: this.props.fontSize + 'rem'}}>
        <PrintHeader />
        <MapHeader />
        {this.props.children}
      </div>
    );
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default withStyles(s)(connect(mapState)(MapLayout));



// WEBPACK FOOTER //
// src/components/MapLayout/MapLayout.js